
export enum EEventType {
  /**
   * 点击事件
   */
  onClick = 'onClick',

  /**
   * change事件
   */
  onChange = 'onChange',

  /**
   * 搜索事件
   */
  onSearch = 'onSearch',

  /**
   * 移除
   */
  onRemove = 'onRemove',

  /**
   * 重置
   */
  onReset = 'onReset',

  /**
   * 保存
   */
  onSave = 'onSave',

  /**
   * tab点击变化事件
   */
  onTabChange = 'onTabChange',
  /**
   * 渲染时
   */
  onRender = 'onRender',

  /**
   * 组件挂载时
   */
  onComponentDidMount = 'onComponentDidMount',

  /**
   * 输入框focus事件
   */
  onFocus = 'onFocus',

  /**
   * 输入框失焦事件
   */
  onBlur = 'onBlur',

  /**
   * 切换事件
   */
  onToogle = 'onToogle',

  /**
   * 爆炸图💥点击
   */
  onIndustryComponetClick = 'onIndustryComponetClick',

  /**
   * 错误重载事件
   */
  onErrorReload = 'onErrorReload',
  /**
   * 切换商品捆绑模式
   */
  onModeChange = 'onModeChange',
  /**
   * 关闭提示弹框
   */
  onClosePopover  = 'onClosePopover',
  /**
   * 关闭筛选器保存条件提示
   */
  onCloseSaveTips = "onCloseSaveTips"
}



// WEBPACK FOOTER //
// ./src/enums/EEventType.ts